import { render, staticRenderFns } from "./InvoiceManage.vue?vue&type=template&id=452f7dfa"
import script from "./InvoiceManage.vue?vue&type=script&lang=js"
export * from "./InvoiceManage.vue?vue&type=script&lang=js"
import style0 from "./InvoiceManage.vue?vue&type=style&index=0&id=452f7dfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports